import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How Ayrton Senna can make you a better anything",
  "description": "",
  "published": "2011-08-12T00:00:00.000Z",
  "redirect_from": ["/blog/how-ayrton-senna-can-make-you-a-better-anything/swizec/2167"],
  "categories": "Alain Prost, Auto racing, Ayrton Senna, Formula One, Jeremy Clarkson, Michael Schumacher, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/5648756796_9b48467eec_m.jpg",
        "alt": "Ayrton Senna show 06",
        "title": "Ayrton Senna show 06"
      }}></img></p>
    <p>{`Last night `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-10-8/swizec/2124",
        "title": "I learned two things today 10.8."
      }}>{`I watched a documentary about Senna`}</a>{` and if you are into `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Motorsport",
        "title": "Motorsport"
      }}>{`motor sports`}</a>{` at all, or just like watching movies about inspirational people, you should totally watch it. If you can't swing the time, at least go have a look at last year's `}<a parentName="p" {...{
        "href": "http://www.youtube.com/results?search_query=top+gear+senna&page=&utm_source=opensearch"
      }}>{`Top Gear Senna tribute`}</a>{`.`}</p>
    <p>{`There is a quote from the movie that really stands out for me:`}</p>
    <blockquote>
      <p parentName="blockquote">{`By being a `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Auto_racing",
          "title": "Auto racing"
        }}>{`racing driver`}</a>{` you are under risk all the time. By being a racing driver means you are racing with other people. `}<strong parentName="p">{`And if you no longer go for a gap that exists, you are no longer a racing driver`}</strong>{` because we are competing, competing to win. And the main motivation to all of us is to compete for victory, it's not to come 3rd, 4th, 5th or 6th. I race to win as long as I feel it's possible. Sometimes you get it wrong? Sure, it's impossible to get it right all the time. But I race designed to win, as long as I feel I'm doing it right.`}</p>
    </blockquote>
    <p>{`I believe Senna said this to explain why he crashed out `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Alain_Prost",
        "title": "Alain Prost"
      }}>{`Alain Prost`}</a>{` in the first corner of some championship deciding race (I forget which). An event that was possibly the saddest way to become a world championship ever, but nevertheless.`}</p>
    <p>{`But the circumstances don't really matter.`}</p>
    <p>{`The important bit is that `}<em parentName="p">{`if you no longer go for a gap that exists, you are no longer a racing driver.`}</em></p>
    {
      /*more*/
    }
    <p>{`Think about it.`}</p>
    <p>{`Try to really take it in.`}</p>
    <p>{`Say it out loud. Let that phrase roll off your tongue with feeling. Go on, say it.`}</p>
    <p>{`Do you hear it?`}</p>
    <p>{`It is the sound, nay, the philosophy, of a man who is considered the greatest expert in his field. Not the greatest living expert. Not the greatest expert from some era. `}<em parentName="p">{`THE`}</em>{` greatest expert.`}</p>
    <p>{`Ask anyone. Even `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Michael_Schumacher",
        "title": "Michael Schumacher"
      }}>{`Schumacher`}</a>{` who has the most recors says that Senna was better. Top Gear has it on video, they asked the greatest living experts of the field and they all unanimously agreed that Senna was `}<em parentName="p">{`the`}</em>{` best F1 driver ever.`}</p>
    <p>{`Can we learn from this philosophy?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Michael_Schumacher1.jpg",
        "alt": "Michael Schumacher, German racing driver",
        "title": "Michael Schumacher, German racing driver"
      }}></img></p>
    <p>{`Let's bastardize it a little bit -> "if you no longer go for `}{`<`}{`opportunity> you are no longer `}{`<`}{`that which you are>". Just insert the appropriate words for your situation.`}</p>
    <p>{`The point is, once you start taking shortcuts, the first time you say "Eh, I'll let it slide this time, I'll try harder next time" ... fuck that shit. You've already lost. The first time you say to yourself `}{`_`}{`I could code this better, but they're not paying enough `}{`_`}{`you are no longer a programmer. The first time you go `}{`_`}{`Oh that's a cool opportunity, but I'm busy with this other thing and I wanted to watch that cool movie `}{`_`}{`you are no longer an entrepreneur.`}</p>
    <p>{`But I guess not all of us can be as great in our respective fields as Senna was in his. Maybe we get to flake out a few times. It just matters how often you do it. And sometimes it is probably better to let an opportunity slide if it opens up resources to chase a bigger and better opportunity (you could argue that then the "gap" did not exist, I'm sure `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ayrton_Senna",
        "title": "Ayrton Senna"
      }}>{`Ayrton`}</a>{` skipped many gaps that weren't good enough).`}</p>
    <p>{`Just keep the quote in mind.`}</p>
    <p>{`We already let slide enough opportunities for being awesome subconsciously for this or that reason, there's no need to make excuses. If you don't beat yourself up at least a little bit every time, then you will let slide too many.`}</p>
    <p>{`And here's a bonus quote by `}<a parentName="p" {...{
        "href": "http://www.myspace.com/everything/jeremy-clarkson",
        "title": "Jeremy Clarkson"
      }}>{`Jeremy Clarkson`}</a>{` about Senna that speaks a lot about what more of us perhaps should try striving to:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Villeneuve (or any of the other greats for that matter...Prost, Hill, `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Nigel_Mansell",
          "title": "Nigel Mansell"
        }}>{`Mansell`}</a>{`, etc) were spectacular a number of times. Senna was spectacular every single time.`}</p>
    </blockquote>
    <p>{`Do you want to be spectacular a number of times or `}<em parentName="p">{`every`}</em>{` time?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jalopnik.com/5826851/when-fangio-met-senna-and-schumacher"
        }}>{`When Fangio met Senna and Schumacher `}{`[`}{`Video`}{`]`}</a>{` (jalopnik.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.npr.org/2011/08/11/139084426/senna-the-fast-paced-life-of-a-champion-racer?ft=1&f=1008"
        }}>{`'Senna': The Fast-Paced Life Of A Champion Racer`}</a>{` (npr.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jalopnik.com/5823354/ayrton-sennas-singular-relentless-magic"
        }}>{`Ayrton Senna's singular, relentless magic `}{`[`}{`Video`}{`]`}</a>{` (jalopnik.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.avclub.com/articles/senna,60240/"
        }}>{`Film: Movie Review: Senna`}</a>{` (avclub.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=60a061c1-53f9-4ae4-a23a-98750577b86b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      